"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = (haystack, sliceLength) => {
  const slices = [];
  let index = 0;

  while (index < haystack.length) {
    const result = haystack.slice(index, index + sliceLength);

    if (result.length === sliceLength) {
      slices.push(result);
    }

    index++;
  }

  return slices;
};

exports.default = _default;
//# sourceMappingURL=createMovingChunks.js.map